import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableTitle from "./TableTitle";
import TableHeader from "./TableHeader";
import TableData from "./TableData";
import { TableFooter, TablePagination } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),

    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  tableContainer: {
    // borderRadius: 10,
    // borderTopLeftRadius: 0,
    // borderTopRightRadius: 0,
  },
  table: {
    flexGrow: 1,
  },
}));

const Tabular = ({ data }) => {
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [longFields, setLongFields] = React.useState();

  const rows = data.rows || [];
  const ScrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    return null;
  };
  const handleChangePage = (e, newPage) => {
    // console.log("page", newPage);
    setPage(newPage);
    ScrollToTop();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const rowData =
    rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];

  React.useEffect(() => {
    if (rowData) {
      let localLongfields = [];
      let printCount = 0;
      rowData.forEach((element) => {
        Object.keys(element).map((subele) => {
          // let eleValue = subele[]
          if (
            !localLongfields.includes(subele) &&
            element[subele]?.length > 20 &&
            !element[subele]?.includes("uploads")
          ) {
            localLongfields.push(subele);
          }
        });
      });

      setLongFields(localLongfields);
    }
  }, [rowData]);

  return (
    <div className={classes.root}>
      {data?.title && <TableTitle title={data?.title} />}
      <Paper>
        <TableContainer
          className={classes.tableContainer}
          variant="elevation"
          elevation={2}
        >
          <Table className={classes.table} aria-label="simple table">
            <TableHeader
              data={data.header}
              srnotitle={data.srnotitle}
              longFields={longFields}
            />
            <TableBody>
              <TableData
                page={page}
                rowsPerPage={rowsPerPage}
                data={rowData}
                header={data.header}
              />
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={rowsPerPage}
          // colSpan={3}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};
export default Tabular;
